import { get } from './request';

export default function getLanguages() {
  return get('/api/language').then((languages) => {
    return languages;
  });
}
